// @flow

/* eslint-disable ta-code-conventions/has-matching-test */
/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';
import { Query } from 'react-apollo';
import { Icon } from '@ta/styleguide.icon';
import { ResponsiveImage } from '@ta/media.image';
import { type TypeaheadResult } from '../TypeaheadResult';
import styles from './POIObjectList.less';
import LocationDetailsQuery from './LocationDetails.gql';

type Props = {|
  selectedLocations: Map<string, TypeaheadResult>,
  onClose?: string => void,
|};

/* This is a temporarily created object that duplicates the POIObject under social. It will be removed once we move VideoUploaderModal under /packages/media */
const POIObjectList = ({ selectedLocations, onClose }: Props) => (
  <Query
    errorPolicy="all"
    query={LocationDetailsQuery}
    variables={{ locationIds: Array.from(selectedLocations.keys()).map(k => parseInt(k, 10)) }}
  >
    {({ loading, data }) => {
      if (loading || !data || !data.locations || !data.locations[0]) {
        return null;
      }

      const displayPoi = poi => {
        let secondaryText;
        if (poi?.placeType === 'CITY') {
          /* $FlowFixGraphql (WP-1357) */
          secondaryText = poi?.additionalNames?.longOnlyParent;
        } else {
          secondaryText = poi?.parent?.additionalNames?.long;
        }

        let icon;

        switch (poi?.placeType) {
          case 'ACCOMMODATION':
            icon = 'hotels';
            break;
          case 'ATTRACTION':
            icon = 'attractions';
            break;
          case 'ACTIVITY':
            icon = 'activities';
            break;
          case 'CITY':
            icon = 'globe-world';
            break;
          case 'EATERY':
            icon = 'restaurants';
            break;
          default:
            icon = '';
        }

        const thumbSize = '60px';

        return (
          <div
            /* $FlowFixGraphql (WP-1357) */
            key={`poi_tag_${poi?.locationId}`}
            className={`${styles.poi_block} ${styles.relative_container}`}
          >
            <div className={styles.poi_thumbnail}>
              {/* $FlowFixGraphql (WP-1357) */}
              {poi?.thumbnail ? (
                <ResponsiveImage
                  /* $FlowFixGraphql (WP-1357) */
                  sources={poi?.thumbnail?.photoSizes}
                  width={thumbSize}
                  height={thumbSize}
                  notLazy={false}
                  borderRadius="2px"
                />
              ) : (
                <div style={{ width: thumbSize, height: thumbSize }}>
                  <div className={styles.no_photo_available}>
                    <Icon name={icon} className={styles.icon} />
                  </div>
                </div>
              )}
            </div>
            <div className={styles.poi_info_vertical_center}>
              <div className={styles.poi_info}>
                <div className={styles.poi_name}>{poi?.name}</div>
                <div className={styles.poi_location}>{secondaryText}</div>
              </div>
            </div>
            {/* $FlowFixGraphql (WP-1357) */}
            {onClose && poi?.locationId ? (
              <div
                className={`ui_icon times ${styles.trashIcon}`}
                /* $FlowFixGraphql (WP-1357) */
                onClick={() => onClose(poi.locationId.toString())}
              />
            ) : null}
          </div>
        );
      };

      return <React.Fragment>{data.locations.map(poi => displayPoi(poi))}</React.Fragment>;
    }}
  </Query>
);

POIObjectList.defaultProps = {
  onClose: undefined,
};

export default POIObjectList;
